:host {
}

.stzh-vbz-ticker {
  display: flex;
  flex-direction: column;
  position: relative;

  @include mq($from: medium) {
    flex-direction: row;
    align-items: flex-start;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--stzh-space-xsmall);
  }

  &__icon {
    --size: #{iconSize('small')};
    margin-right: space('xsmall');
  }

  &__title {
    @include font;
    @include fontCurve('p1');
    display: flex;
    flex-wrap: wrap;
  }

  &__title-parts {
    display: flex;
    flex-wrap: wrap;
    margin: calc(#{space('xxxsmall')} / -1) 0;
  }

  &__title-part {
    display: flex;
    align-items: center;
    white-space: nowrap;
    margin: space('xxxsmall') 0;
    color: $colorGrey90;


    &:not(:last-child) {
      margin-right: space('large');
    }

    &--major-events {
      color: $colorCoral;
    }

    &--disturbances {
      color: $colorError60;
    }
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    gap: 0 var(--stzh-space-xsmall);
  }

  &__tooltip {
    --width: 334px;
  }

  &__disturbance {
    display: flex;
    align-items: flex-start;

    &:not(:first-child) {
      margin-top: space('small');
    }
  }

  &__disturbance-title {
    @include font;
    @include fontSize('micro');
    display: flex;
  }

  &__disturbance-date {
    @include font;
    @include fontSize('micro');
    margin-top: space('xsmall');
  }

  &__disturbance--type0 &__disturbance-title,
  &__disturbance--type2 &__disturbance-title {
    @include font('heavy');
  }

  &__disturbance-icon {
    --size: #{iconSize('xsmall')};
    margin-top: space('xxxsmall');
    margin-right: space('xsmall');
  }

  &__disturbance-link {
    margin-top: space('xsmall');
  }
}

